/**
 * The translated loading state: the Suspense fallback of the lazy book routes and the pages'
 * own loading state (ebook-plan § 3.13).
 */
import { Loader2 } from 'lucide-react';
import { useLanguage } from '@/store';
import { getBookTranslation } from '@/utils/translations';

export function BookLoading() {
  const language = useLanguage();
  return (
    <div role="status" className="flex min-h-[40vh] flex-col items-center justify-center gap-3" data-testid="book-loading">
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
      <span className="text-sm opacity-80">{getBookTranslation('loading', language)}</span>
    </div>
  );
}
